<template>
  <Layout2
    title="User Verification"
    padTop="50px"
  >
    <template slot="form">
      <div class="p-0 mt-3">
        <div class="form-floating mb15">
          <input
            v-model="user_email"
            label="Email"
            v-validate="'required'"
            data-vv-name="email"
            disabled
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            class="form-control fn14"
          />
          <label for="email">Email</label>
          <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small>
        </div>

        <div class="form-floating mb15">
          <input
            v-model="emailVerifyCode"
            placeholder="Verification Code"
            v-validate="{required: true, alpha_num: true}"
            data-vv-name="code"
            type="text"
            id="code"
            name="code"
            class="form-control fn14"
          />
          <label for="code">Verification Code</label>
          <small class="col_error" v-show="errors.has('code')">{{ errors.first('code') }}</small>
        </div>
      </div>
      <div class="p-0 mt-2">
        <vue-recaptcha v-if="!(emailVerified)" id="recaptcha" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSiteKey" size="invisible">
        </vue-recaptcha>
        <input type="submit" class="btn btn-apiculus-primary" :disabled="!verificationCodeValid" v-if="!(emailVerified)" @click="initiateEmailVerification()" value="VERIFY EMAIL" />
      </div>
    </template>
  </Layout2>
</template>

<script>
import Layout2 from '@/components/New/Layout2.vue'
import VueRecaptcha from 'vue-recaptcha'
import helpers from '../services/toast-service'

export default {
  name: 'emailUpdateVerification',
  mixins: [helpers],
  components: { 
    Layout2,
    VueRecaptcha 
  },
  data: () => ({
    color: '',
    message: '',
    user_email: '',
    emailVerifyCode: '',
    emailVerified: false,
    recaptcha_response: ''
  }),
  computed: {
    getUserEmail () {
      // console.log(this.$route, this.$route.query.email)
      return this.$route.query.email || ''
    },
    verificationCodeValid () {
      // console.log(this.emailVerifyCode && this.fields.code && this.fields.code.valid)
      return this.emailVerifyCode && this.fields && this.fields.code && this.fields.code.valid
    },
    recaptchaSiteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  mounted () {
    this.user_email = this.getUserEmail
  },
  methods: {
    onCaptchaVerified (res) {
      // console.log('onCaptchaVerified >> ', res)
      if (res && res.length) {
        this.recaptcha_response = res
        this.verifyEmail()
      } else {
        this.toastAlert('Error in verifying the reCAPTCHA', 'error')
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    initiateEmailVerification () {
      this.$refs.recaptcha.execute()
    },
    verifyEmail () {
      console.log('token :: ', this.recaptcha_response)
      if (this.recaptcha_response && this.verificationCodeValid) {
        let reqBody = {
          'email': this.user_email,
          'tempPassword': this.emailVerifyCode,
          'g-recaptcha-response': this.recaptcha_response,
          'id': this.$route.query.id
        }
        this.$store.dispatch('ACTION_VERIFY_UPDATE_EMAIL', reqBody).then((res) => {
          if (res.success) {
              this.toastAlert("Primary Email Updated Successfully!", 'success')
              this.emailVerified = true
              setTimeout(() => {
                this.$router.push('/')
              }, 3000)
          } else if (res.error && (res.error.internalMessage == "Wrong code entered" || res.error.message == "Wrong code entered")) {
              this.toastAlert("Please enter correct verification code.", 'error')
          } else {
            this.toastAlert(res.error.internalMessage || res.error.message || 'Verification link invalid/expired. Please try to resend the verification link.', 'error')
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
          }
        })
      }
    },
  }
}
</script>

<style>
.verification-link {
  margin-top: 20vh
}
</style>
